import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { GET_TIME_PROFILES } from '../get-time-profiles';
import { deleteTimeProfilesAPI } from './api';

export function useDeleteTimeProfile() {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();
  
  const mutation = useMutation((id) => deleteTimeProfilesAPI(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([GET_TIME_PROFILES, tenantId]);
      openModal({
        modalType: 'NotificationModal',
        modalProps: {
          type: 'success',
          description: 'deleteTimeProfileSuccessMessage',
        },
      });
    },
    onError: (error) => {
      if (error?.errorMessage?.includes('Cannot delete time profile which is assigned to an access rule!')) {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'deleteTimeProfileInUseErrorMessage',
          },
        });
      } else {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'genericErrorMessage',
          },
        });
      }
    },
  });

  return {
    ...mutation,
  };
}

